<template>
	<div class="topic_sum">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right"><Breadcrumb /></div>
									<h3 class="header-title mb-3">征文评审区级管理</h3>
								</div>
								<!-- end page-title-box -->
							</div>
							<!-- end col-->
						</div>
						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<el-table id="table" :header-cell-style="tableStyle" border :data="topicSumData" style="width: 100%;margin-bottom: 20px;">
											<el-table-column prop="projectName" label="通知名称" width="350"></el-table-column>
											<el-table-column prop="projectTypeName" label="提交作品"  width="80"></el-table-column>
											<el-table-column prop="createUserName" label="发布人" width="100"></el-table-column>
											<el-table-column prop="declareEndTime" label="上传截止时间"></el-table-column>
											<el-table-column prop="trialEndTime" label="初审截止日期"></el-table-column>
											<el-table-column prop="projectUnitName" label="操作" width="200">
												<template v-slot:default="scope">
													<el-button type="primary" @click="goRoute(`/backstage/checkDistrictManage?id=${scope.row.id}&createId=${scope.row.createId}`)">进入管理</el-button>
													<el-button type="text"  v-if="userInfo.id==scope.row.createId||show" @click="goRoute(`/backstage/deliverAnnouncement?type=${1}&id=${scope.row.id}`)">修改</el-button>
													<el-button type="text"  v-if="userInfo.id==scope.row.createId||show" @click="delRowBtn(scope.row)">删除</el-button>
												</template>
											</el-table-column>
										</el-table>
										<!-- 只有主管领导才显示 -->
										<div><el-button size="mini" type="primary" @click="goRoute('/backstage/deliverAnnouncement')" v-show="show">创建评审</el-button></div>
										<div class="pagination">
											<el-pagination
												@size-change="handleSizeChange"
												@current-change="handleCurrentChange"
												:current-page="pageNumber"
												:page-sizes="[50, 100, 200]"
												:page-size="pageSize"
												layout="total, sizes, prev, pager, next, jumper"
												:total="underStudyTopicTotal"
											></el-pagination>
										</div>
									</div>
									<!-- end card-body-->
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import { getProjectList, delEduProject } from '@/api/after/newInterface';
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
export default {
	components: {
		Breadcrumb
	},
	data() {
		return {
			tableStyle: {
				backgroundColor: '#7e9be2',
				color: '#fff',
				textAlign: 'center'
			},
			topicSumData: [],
			underStudyTopicTotal: 10,
			pageNumber: 1,
			pageSize: 20,
			userInfo:""
		};
	},
	created() {
		this.getTable();
		
		
	},
	methods: {
		// 删除
		delRowBtn(row) {
			console.log(this.userInfo.id==row.createId);
			this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					delEduProject(row.id).then(res => {
						if (res.code == 200) {
							this.$message.success(res.msg);
							this.getTable();
						} else {
							this.$message.error('本通知下已经提交了作品，不允许删除');
						}
					
					});
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getTable();
		},
		handleCurrentChange(val) {
			this.pageNumber = val;
			this.getTable();
		},
		goRoute(url) {
			this.$router.push({ path: url });
		},
		getTable() {
			let params = {
				pageNumber: this.pageNumber,
				pageSize: this.pageSize,
				type: 1,
				role:1
			};
			getProjectList(params).then(res => {
				if (res.code == 200) {
					this.topicSumData = res.data.records;
					this.userInfo=JSON.parse(sessionStorage.getItem("userInfo"))
					this.show=this.userInfo.roleId.indexOf("9")!=-1
					console.log(this.show);
					this.underStudyTopicTotal = res.data.total;
				} else {
					this.$message.error(res.msg);
				}
				
			});
		}
	}
};
</script>

<style scoped lang="scss">
::v-deep .el-date-editor.el-input {
	width: 100%;
}
.btn_wrap {
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	// justify-content: space-between;
}
.pagination {
	display: flex;
	justify-content: center;
}
</style>
